import API from '../../utils/api';
import { setError } from './errors';
import * as types from './types';
import { AGENT_SERVICE_ENDPOINT_URL, internalError } from '../../constants/defaultValues';
import { GET_SPORT_TYPES_SUCCESS, RESET_SPORT_TYPES } from './types';

export const getSportTypes =
    ({ isLive, eventType, eSport = false }) =>
    async dispatch => {
        dispatch({
            type: types.GET_SPORT_TYPES_REQUEST,
        });
        await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/sports?live=${isLive}&eventType=${eventType}&eSport=${eSport}`)
            .then(response => {
                const { info, items } = response.data;
                if (info.success) {
                    dispatch({
                        type: types.GET_SPORT_TYPES_SUCCESS,
                        payload: items,
                    });
                }
            })
            .catch(err => {
                const errors = err?.response?.data?.info?.errors;
                if (!errors) {
                    dispatch(setError(internalError));
                    return false;
                }
                dispatch(setError(errors[0]));
            });
    };

export const setSportsList = list => ({
    type: GET_SPORT_TYPES_SUCCESS,
    payload: list,
});

export const resetSportsList = () => ({
    type: RESET_SPORT_TYPES,
});
